import $ from 'jquery';
import Component from "../models/Component";

export default class SocialShare extends Component {
  constructor(element, context) {
    super(element, context);
    this.init();
  }

  init() {
    this.element.on('click', function () {
      let screen_width = screen.width,
        screen_height = screen.height,
        popup_width = screen_width - (screen_width * .2),
        popup_height = screen_height - (screen_height * .2),
        left = (screen_width / 2) - (popup_width / 2),
        top = (screen_height / 2) - (popup_height / 2),
        parameters = 'toolbar=0,status=0,width=' + popup_width + ',height=' + popup_height + ',top=' + top + ',left=' + left;

      return window.open($(this).attr('href'), '', parameters) && false;
    });
  }
}